module.exports = __webpack_public_path__ + "static/005.thumb-03142920b3a478eb099aae5b8c1ae1c6.jpg";